module.exports = __webpack_public_path__ + "img/Tonga.3bd868b0.svg";